import { Logger } from "neo-common";

/**
 * Definitions for payline for all kind of reels.
 * @class PaylinesDefinitions
 */
export class PaylinesDefinitions {
    private static _paylineGroupsDefinitions: Object = {};

    /**
     * Initialize payline definiftion specific for game.
     * @method initializePaylineDefinitions
     * @param paylineGroupId string
     * @return void
     */
    static initializePaylineDefinitions(paylineGroupId: string) {
        var definition: Object = {};

        switch (paylineGroupId) {
            case "6x4":
                definition[1] = [1, 1, 1, 1, 1, 1];
                definition[2] = [0, 0, 0, 0, 0, 0];
                definition[3] = [2, 2, 2, 2, 2, 2];
                definition[4] = [3, 3, 3, 3, 3, 3];
                definition[5] = [1, 0, 0, 0, 0, 1];
                definition[6] = [0, 1, 1, 1, 1, 0];
                definition[7] = [2, 3, 3, 3, 3, 2];
                definition[8] = [3, 2, 2, 2, 2, 3];
                definition[9] = [1, 2, 2, 2, 2, 1];
                definition[10] = [2, 1, 1, 1, 1, 2];
                definition[11] = [1, 0, 1, 0, 1, 0];
                definition[12] = [2, 3, 2, 3, 2, 3];
                definition[13] = [1, 2, 1, 2, 1, 2];
                definition[14] = [2, 1, 2, 1, 2, 1];
                definition[15] = [0, 1, 0, 1, 0, 1];
                definition[16] = [3, 2, 3, 2, 3, 2];
                definition[17] = [1, 1, 0, 0, 1, 1];
                definition[18] = [2, 2, 3, 3, 2, 2];
                definition[19] = [0, 0, 1, 1, 0, 0];
                definition[20] = [3, 3, 2, 2, 3, 3];
                definition[21] = [1, 1, 2, 2, 1, 1];
                definition[22] = [2, 2, 1, 1, 2, 2];
                definition[23] = [0, 0, 1, 2, 3, 3];
                definition[24] = [3, 3, 2, 1, 0, 0];
                definition[25] = [1, 1, 1, 0, 0, 0];
                definition[26] = [2, 2, 2, 3, 3, 3];
                definition[27] = [0, 0, 0, 1, 1, 1];
                definition[28] = [3, 3, 3, 2, 2, 2];
                definition[29] = [1, 1, 1, 2, 2, 2];
                definition[30] = [2, 2, 2, 1, 1, 1];
                definition[31] = [0, 0, 0, 1, 2, 3];
                definition[32] = [3, 3, 3, 2, 1, 0];
                definition[33] = [1, 1, 2, 3, 2, 1];
                definition[34] = [2, 2, 1, 0, 1, 2];
                definition[35] = [0, 1, 1, 2, 2, 3];
                definition[36] = [3, 2, 2, 1, 1, 0];
                definition[37] = [1, 2, 3, 2, 1, 0];
                definition[38] = [2, 1, 0, 1, 2, 3];
                definition[39] = [0, 1, 2, 3, 2, 1];
                definition[40] = [3, 2, 1, 0, 1, 2];
                definition[41] = [0, 1, 2, 1, 0, 1];
                definition[42] = [3, 2, 1, 2, 3, 2];
                definition[43] = [0, 1, 2, 1, 2, 3];
                definition[44] = [3, 2, 1, 2, 1, 0];
                definition[45] = [1, 2, 3, 3, 2, 1];
                definition[46] = [2, 1, 0, 0, 1, 2];
                definition[47] = [0, 1, 2, 2, 1, 0];
                definition[48] = [3, 2, 1, 1, 2, 3];
                definition[49] = [1, 0, 1, 2, 3, 2];
                definition[50] = [2, 3, 2, 1, 0, 1];
                break;
            default:
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
                return;
        }

        this._paylineGroupsDefinitions[paylineGroupId] = definition;
    }

    /**
     * Get payline by id and group id.
     * @method getPaylineDefinitionsById
     * @param paylineId string
     * @param paylineGroupId string
     * @return void
     */
    static getPaylineDefinitionsById(paylineId: number, paylineGroupId: string): Array<number> {
        if (this._paylineGroupsDefinitions != null) {
            if (this._paylineGroupsDefinitions[paylineGroupId] != null) {
                if (this._paylineGroupsDefinitions[paylineGroupId][paylineId] != null) {
                    return this._paylineGroupsDefinitions[paylineGroupId][paylineId];
                } else {
                    if (DEBUG) {
                        this.log("ERROR no paylineId: " + paylineId + " in " + paylineGroupId);
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no paylines definitions");
            }
        }
        return null;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("PaylineDefinitions", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/PaylinesDefinitions.ts
 **/